import React from 'react';
import { FormattedMessage } from 'react-intl';

import { DangerAlert, SuccessAlert, WarningAlert } from '@tmapy/style-guide';

import type { EpsiRetryState } from './useEpsiRetry';
import { epsiMessages } from './epsiMessages';

export type EpsiRetryAlertProps = {
  state: EpsiRetryState;
  onHide(): void;
};

/**
 * Hláška o výsledku retry — sdílí ji přehled i detail, ať se obě obrazovky
 * chovají na stejné stavy stejně. V přehledu se renderuje pod dotčeným řádkem
 * (hláška v hlavičce by uživateli, který klikl dole v dlouhém seznamu, utekla
 * z dohledu), v detailu pod tlačítkem.
 */
export const EpsiRetryAlert: React.FC<EpsiRetryAlertProps> = ({ state, onHide }) => {
  switch (state.phase) {
    case 'accepted':
      return (
        <SuccessAlert onHideBtnClick={onHide}>
          <FormattedMessage {...epsiMessages.retryStarted} />
        </SuccessAlert>
      );

    case 'conflict':
      // Důvodů odmítnutí má BE několik, rozlišuje je jen textem v `detail`.
      return (
        <WarningAlert onHideBtnClick={onHide}>
          {state.detail ?? <FormattedMessage {...epsiMessages.retryConflict} />}
        </WarningAlert>
      );

    case 'forbidden':
      return (
        <DangerAlert onHideBtnClick={onHide}>
          <FormattedMessage {...epsiMessages.retryForbidden} />
        </DangerAlert>
      );

    case 'unavailable':
      return (
        <DangerAlert onHideBtnClick={onHide}>
          <FormattedMessage {...epsiMessages.retryUnavailable} />
        </DangerAlert>
      );

    case 'fail':
      return (
        <DangerAlert onHideBtnClick={onHide}>
          <FormattedMessage {...epsiMessages.retryFail} />
        </DangerAlert>
      );

    // `waiting` se hlásí spinnerem na tlačítku, vlastní řádek nepotřebuje.
    default:
      return null;
  }
};
